import {
  Flex,
  Modal,
  Text,
  ActionIcon,
  Image,
  Button,
  Stack,
} from "@mantine/core";

export const WarningModal = ({
  opened,
  onClose,
  onConfirm,
}: {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Modal
      centered
      opened={opened}
      onClose={onClose}
      withCloseButton={false}
      size="lg"
    >
      <Stack p="md">
        <Flex justify="space-between" align="center">
          <Text fw={600} size="lg">
            Remove Question?
          </Text>
          <ActionIcon onClick={onClose} variant="transparent">
            <Image
              src="/assets/circle-x.svg"
              alt="Close question modal"
              h={20}
            />
          </ActionIcon>
        </Flex>
        <Flex justify="center" align="center">
          <Text size="sm">
            Are you sure you want to remove this question? This action is
            permanent and can&apos;t be reversed.
          </Text>
        </Flex>
        <hr className="mx-4" />
        <Flex justify="start" align="center" gap="sm">
          <Button
            variant="filled"
            className="bg-[#F45A5A] text-white"
            onClick={onConfirm}
          >
            Remove Question
          </Button>
          <Button variant="light" color="black" onClick={onClose}>
            Cancel
          </Button>
        </Flex>
      </Stack>
    </Modal>
  );
};
